module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-iphone_4.d9a894d8.png";